import classNames from 'classnames';
import React from 'react';
import { Image, Subtitle2, Body1 } from '@fluentui/react-components';

import { useNoLocationsStyles } from '../styles/no-locations-styles';
import { i18nProps } from '../utils/types';
import noDataImage from '../../media/no-data-image.png';

export function NoData({ i18n }: { i18n: i18nProps }) {
  const styles = useNoLocationsStyles();
  return (
    <div className={classNames('no-data-container', styles.container)}>
      <div className={styles.imageContainer}>
        <Image className={styles.image} fit="contain" src={noDataImage} alt={i18n.getString(_TL_('No data available'))} />
      </div>
      <Subtitle2 className={classNames('title', styles.title)}>{i18n.getString(_TL_('No data available'))}</Subtitle2>
      <Body1 className="text">{i18n.getString(_TL_('To update the tile, select a different date range. If the tile remains blank, your account might have no data.'))}</Body1>
    </div >
  );
}
